module.exports = __webpack_public_path__ + "static/media/amslogo-1.a3313506.png";